import keyboardFocus from 'keyboard-focus';
import { initScroll } from '../plugins/smooth-scroll';
import { getElements, isWindows } from '../helpers/functions';
const historyBack = () => {
  const backBtn = getElements('.js-history-back');
  backBtn.forEach($btn => {
    $btn.addEventListener('click', e => {
      if (window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    });
  });
};
export default () => {
  keyboardFocus(document);
  initScroll();
  isWindows();
  historyBack();
};